<template>
	<router-link
		tag="div"
		class="menu-item"
		:to="itemPagePath"
		@click.native="productClicked()"
	>
		<div
			class="item-img"
			:style="{ backgroundImage: `url(${backgroundPath})` }"
		></div>
		<div class="menu-item-bottom">
			<div class="item-name">{{ item.name }}</div>
			<div class="item-price">{{ item.price | currency }}</div>
		</div>
	</router-link>
</template>

<script>
import menuItemMixin from "@/mixins/menu-item-mixin"

export default {
	name: "FeaturedMenuItem",
	mixins: [menuItemMixin],
	data: function () {
		return {
			isFeatured: true
		}
	}
}
</script>

<style scoped>
.menu-item {
	background: var(--gR-white);
	box-shadow: 0px 1px 3px rgba(136, 136, 136, 0.25);
	border-radius: 5px;
	min-height: 110px;
	max-width: 235px;
	margin-bottom: 10px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	flex: 1;
	min-width: 1px;
	margin-right: 0 !important;
}

.menu-item-bottom {
	padding: 10px;
}

.item-price {
	color: var(--sk-grey3);
	font-size: 12px;
}

.item-img {
	background-position: center;
	background-size: cover;
	height: 115px;
	position: relative;
	margin: 5px;
	border-radius: 5px;
}

.item-name {
	color: var(--gR-base-90);
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 5px;
	max-width: 95%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.menu-featured-gallery > div:not(:first-child) {
	margin-left: 10px;
}

@media (min-width: 500px) {
	.menu-featured-gallery > div:not(:first-child) {
		margin-left: 20px;
	}
}
</style>